export enum Role {
  ADMIN = 'admin',
  OPERATOR = 'operator',
  PIC = 'pic',
}
